function n(){return"2.21.0"}export{n as getVersion};
